import {apiCall, HttpMethod} from "./index";
import {FullCredential} from "../types/users";

export async function getApiKeys(ignoreAuthResponse?: boolean): Promise<Credential[]> {
    const res = await apiCall({
        urlComponent: "/users/current/credentials",
        ignoreAuthResponse
    });

    return await res.json();
}

export async function deleteApiKeys(id: string): Promise<void> {
    await apiCall({
        urlComponent: `/users/current/credentials/${id}`,
        method: HttpMethod.DELETE,
    });
}

export async function createApiKey(): Promise<FullCredential> {
    const res = await apiCall({
        urlComponent: `/users/current/credentials`,
        method: HttpMethod.POST,
        body: {},
    });
    return await res.json();
}
